var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconIllustrationMoney(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 35c3.523 0 6.565 2.029 8.043 4.978l-1.788.894A6.992 6.992 0 0032 37a7 7 0 00-6.326 4H31v2h-5.93a7.06 7.06 0 00.001 2.001L31 45v2h-5.326A7 7 0 0032 51a6.993 6.993 0 006.256-3.872l1.787.893C38.565 50.971 35.523 53 32 53a9.003 9.003 0 01-8.488-6H21v-2h2.055a9.101 9.101 0 010-2H21v-2h2.512A9.003 9.003 0 0132 35z",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 72H17c-3.86 0-7-3.14-7-7V49c0-17.639 7.722-21.761 12.832-24.488 1.43-.763 2.664-1.422 3.461-2.219l1.414 1.414c-1.007 1.007-2.363 1.731-3.933 2.569C18.805 28.928 12 32.561 12 49v16c0 2.757 2.243 5 5 5h19v2M54 48h-2c0-16.198-6.672-19.402-11.544-21.742-1.596-.766-3.102-1.49-4.163-2.551l1.414-1.414c.82.82 2.115 1.442 3.614 2.162C46.37 26.879 54 30.544 54 48",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 20v2h10.001L37 20H27zm10 4H27c-1.103 0-2-.897-2-2v-2c0-1.103.897-2 2-2h10c1.103 0 2 .897 2 2v2c0 1.103-.897 2-2 2z",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.618 18h6.764l3.276-6.553L36 10.118l-3.553 1.777c-.281.14-.613.14-.894 0L28 10.118l-2.658 1.329L28.618 18zM36 20h-8c-.379 0-.725-.214-.895-.553l-4-8a1.001 1.001 0 01.448-1.342l4-2c.281-.14.613-.14.894 0L32 9.882l3.553-1.777c.281-.14.613-.14.894 0l4 2a1 1 0 01.447 1.342l-3.999 8c-.17.339-.516.553-.895.553zM38 22v-2c1.654 0 3-1.346 3-3h2c0 2.757-2.243 5-5 5M26 22c-2.757 0-5-2.243-5-5h2c0 1.654 1.346 3 3 3v2M40 68v2h8.001L48 68h-8zm8 4h-8c-1.103 0-2-.897-2-2v-2c0-1.103.897-2 2-2h8c1.103 0 2 .897 2 2v2c0 1.103-.897 2-2 2z",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 64v2h8.001L48 64h-8zm8 4h-8c-1.103 0-2-.897-2-2v-2c0-1.103.897-2 2-2h8c1.103 0 2 .897 2 2v2c0 1.103-.897 2-2 2z",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 60v2h8.001L48 60h-8zm8 4h-8c-1.103 0-2-.897-2-2v-2c0-1.103.897-2 2-2h8c1.103 0 2 .897 2 2v2c0 1.103-.897 2-2 2zM50 68v2h8.001L58 68h-8zm8 4h-8c-1.103 0-2-.897-2-2v-2c0-1.103.897-2 2-2h8c1.103 0 2 .897 2 2v2c0 1.103-.897 2-2 2z",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 64v2h8.001L58 64h-8zm8 4h-8c-1.103 0-2-.897-2-2v-2c0-1.103.897-2 2-2h8c1.103 0 2 .897 2 2v2c0 1.103-.897 2-2 2z",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 60v2h8.001L58 60h-8zm8 4h-8c-1.103 0-2-.897-2-2v-2c0-1.103.897-2 2-2h8c1.103 0 2 .897 2 2v2c0 1.103-.897 2-2 2z",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 56v2h8.001L58 56h-8zm8 4h-8c-1.103 0-2-.897-2-2v-2c0-1.103.897-2 2-2h8c1.103 0 2 .897 2 2v2c0 1.103-.897 2-2 2z",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 52v2h8.001L58 52h-8zm8 4h-8c-1.103 0-2-.897-2-2v-2c0-1.103.897-2 2-2h8c1.103 0 2 .897 2 2v2c0 1.103-.897 2-2 2zM60 68v2h8.001L68 68h-8zm8 4h-8c-1.103 0-2-.897-2-2v-2c0-1.103.897-2 2-2h8c1.103 0 2 .897 2 2v2c0 1.103-.897 2-2 2z",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 64v2h8.001L68 64h-8zm8 4h-8c-1.103 0-2-.897-2-2v-2c0-1.103.897-2 2-2h8c1.103 0 2 .897 2 2v2c0 1.103-.897 2-2 2z",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 60v2h8.001L68 60h-8zm8 4h-8c-1.103 0-2-.897-2-2v-2c0-1.103.897-2 2-2h8c1.103 0 2 .897 2 2v2c0 1.103-.897 2-2 2z",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 56v2h8.001L68 56h-8zm8 4h-8c-1.103 0-2-.897-2-2v-2c0-1.103.897-2 2-2h8c1.103 0 2 .897 2 2v2c0 1.103-.897 2-2 2z",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 52v2h8.001L68 52h-8zm8 4h-8c-1.103 0-2-.897-2-2v-2c0-1.103.897-2 2-2h8c1.103 0 2 .897 2 2v2c0 1.103-.897 2-2 2z",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 48v2h8.001L68 48h-8zm8 4h-8c-1.103 0-2-.897-2-2v-2c0-1.103.897-2 2-2h8c1.103 0 2 .897 2 2v2c0 1.103-.897 2-2 2z",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 44v2h8.001L68 44h-8zm8 4h-8c-1.103 0-2-.897-2-2v-2c0-1.103.897-2 2-2h8c1.103 0 2 .897 2 2v2c0 1.103-.897 2-2 2z",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 34v2h8.001L68 34h-8zm8 4h-8c-1.103 0-2-.897-2-2v-2c0-1.103.897-2 2-2h8c1.103 0 2 .897 2 2v2c0 1.103-.897 2-2 2zM61 30h2v-8h-2zM65 24h2v-8h-2zM61 20h2v-2h-2zM65 28h2v-2h-2z",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h80v80H0z"
  }))));
}

export default SvgIconIllustrationMoney;